<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <base-setting-widget
    :iteminfo="iteminfo"
    ref="base"
    style="position: relative"
    v-bind="$attrs" v-on="$listeners"
  >
    <div
      class="h-30 flex a-center m-v-10 color-33"
      v-if="iteminfo.config.displayType === 2  && iteminfo.config.columnCount == 2">
      <div class="fs-14 color-33">左右间距：</div>
      <Input
        class="fr w-100 m-l-20"
        type="number"
        v-model="iteminfo.config.hSpacing"
      >
        <span slot="append">px</span>
      </Input>
    </div>
    <div
      class="h-30 flex a-center m-v-10 color-33"
      v-if="iteminfo.config.displayType === 2  && iteminfo.config.columnCount == 2">
      <div class="fs-14 color-33">上下间距：</div>
      <Input
        class="fr w-100 m-l-20"
        type="number"
        v-model="iteminfo.config.vSpacing"
      >
        <span slot="append">px</span>
      </Input>
    </div>

    <div class="fs-14 color-33">
      上传图片
    </div>
    <div class="fs-12 color-99 m-t-10">
      建议图片尺寸为750*262，图片格式为png或jpg，图片大小不超过5Mb
    </div>
    <ul class="p-b-50">
      <li :key="index" class="m-b-10" style="background-color: #F2F2F2"
          v-for="(item,index) in iteminfo.config.datalist">
        <div class="flex" style="min-height: 180px">
          <div class="flex-1 p-v-20 p-l-20">
            <div style="min-height: 100px">
              <div class="flex-1 a-center j-center">
                <img :src="getItemUrl(item)" @click="choicePic(item)" alt=""
                     style="width: 100%;cursor: pointer">


                <div class="bg-white flex border m-t-10" style="height: 34px;"
                     v-if="iteminfo.config.isNav"
                     >
                  <Input :border="false" class="b-r" placeholder="导航名称" style="width: 100px"
                         v-model="item.jumpObj.linkName"></Input>
                  <tooltip style="width: 100%"
                           :disabled="!item.jumpObj.linkUrl"
                           max-width="250">

                    <Input :border="false"
                           class="input-link"
                           readonly clearable
                           placeholder="跳转链接地址" v-model="item.jumpObj.linkUrl">
                  <span slot="append" style="cursor: pointer"
                        @click="showMaterialModal(item,index)">  <i class="icon-link"/> </span>
                    </Input>
                    <div slot="content" style="white-space: normal;">
                      {{ item.jumpObj.linkUrl }}
                    </div>
                  </tooltip>
                </div>

<!--                <div-->
<!--                  class="flex-1 m-t-10 flex"-->
<!--                  style="align-items: flex-start" v-if="iteminfo.config.isNav">-->
<!--                  &lt;!&ndash;                  <Input class="" placeholder="导航名称" style=""&ndash;&gt;-->
<!--                  &lt;!&ndash;                         v-model="item.name"></Input>&ndash;&gt;-->
<!--                  <Input :border="false" class="b-r" placeholder="导航名称" style="width: 100px"-->
<!--                         v-model="item.name || item.jumpObj.linkName"></Input>-->
<!--                  <tooltip :disabled="!item.jumpObj.linkUrl"-->
<!--                           max-width="250"-->
<!--                           style="width: 100%">-->

<!--                    <Input clearable placeholder="跳转链接地址"-->
<!--                           readonly style="background-color: white"-->
<!--                           v-model="item.jumpObj.linkUrl">-->
<!--                                        <span @click="showMaterialModal(item,index)" slot="append"-->
<!--                                              style="cursor: pointer">-->
<!--                                          <i class="icon-link"/>-->
<!--                                        </span>-->
<!--                    </Input>-->
<!--                    <div slot="content" style="white-space: normal;">-->
<!--                      {{ item.jumpObj.linkUrl }}-->
<!--                    </div>-->
<!--                  </tooltip>-->
<!--                </div>-->
              </div>
            </div>
          </div>
          <div class="flex a-center" ref="sss">
            <div class="flex-column a-center flex-s-0"
                 style="width: 50px;height:120px;justify-content: space-around;">
              <i @click.stop="onUpClick(index)" class="icon-up fs-18"
                 style="cursor: pointer;color: #666666"/>
              <i @click.stop="onDownClick(index)" class="icon-down fs-18"
                 style="cursor: pointer;color: #666666"/>
              <i @click.stop="onDelClick(index)" class="icon-delete_facet fs-18"
                 style="cursor: pointer;color: #666666"/>
            </div>
          </div>

        </div>
      </li>

    </ul>

    <div class="p-b-20"
         style="position: absolute;bottom: 0;left: 20px;width:calc(100% - 40px);z-index: 999;background-color: white">
      <div @click="onItemAddClick" class="flex a-center j-center" key="abc"
           style="height: 48px;border:1px dashed #D8D8D8;cursor: pointer;background-color: #F2F2F2">
        <Icon size="24" type="ios-add"/>
        <!--{{ iteminfo.name }}-->
        <div class="m-l-2">添加图片</div>
      </div>
    </div>

    <pic-choice-widget
      :on-ok="picChoiceOk"
      ref="picChoiceWidget"
    />
    <materail-choice-weidget
      :on-ok="materialChoiceOk"
      ref="materialChoiceWidget"
      title="选择链接"/>
  </base-setting-widget>
</template>

<script>
import BaseSettingWidget from '../base/BaseSettingWidget'
import UpLoadImage from '../../common/UpLoadImage'
import PicChoiceWidget from '@/components/common/chiose/PicChoiceWidget'
import MaterailChoiceWeidget from '@/components/common/chiose/MaterialChoiceWidget'

export default {
  name: 'PicSettingWidget',
  components: {MaterailChoiceWeidget, PicChoiceWidget, UpLoadImage, BaseSettingWidget},
  props: {
    iteminfo: Object
  },
  data () {
    return {
      clickItem2ShowPicModal: {},
      clickItem2ShowMaterialModal: {},
      showPicChoiceModal: false,
      clickedItem2ShowModal: 0,
      dataList: [],
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
    },
    onItemAddClick () {
      this.iteminfo.config.datalist.push({
        'id': 0,
        'cid': 0,
        'ccid': 0,
        'cccid': 0,
        'title': '',
        'picurl': '',
        'jumpurl': '',
        'width': 0,
        'height': 0,
        'jumpObj': {
          'linkUrl': '',
          'linkName': '',
          'shareTitle': '',
          'shareCover': '',
          'showVideoTitle': 0,
          'showTime': 0,
          'displayType': 1,
          'subDisplayType': 1,
          'ratio': 2,
          'hSpacing': 0,
          'vSpacing': 0,
          'pSee': 1,
          'pPublish': 1,
          'pDevices': 1,
          'pUsers': [],
          'columnCount': 2
        }
      },)

      this.$nextTick(() => {
        if (this.$refs.base && this.$refs.base.$refs.scrollDiv) {
          let scrollHeight = this.$refs.base.$refs.scrollDiv.scrollHeight
          this.$refs.base.$refs.scrollDiv.scrollTo({top: scrollHeight, behavior: 'smooth'})
        }
      })
    },
    onUpClick (index) {
      if (index > 0) {
        let item = this.iteminfo.config.datalist[index - 1]
        this.iteminfo.config.datalist.splice(index - 1, 1)
        this.iteminfo.config.datalist.splice(index, 0, item)
      }
    },
    onDownClick (index) {
      if (index < (this.iteminfo.config.datalist.length - 1)) {
        let item = this.iteminfo.config.datalist[index + 1]
        this.iteminfo.config.datalist.splice(index + 1, 1)
        this.iteminfo.config.datalist.splice(index, 0, item)
      }
    },
    onDelClick (index) {
      let datalist = this.iteminfo.config.datalist
      datalist.splice(index, 1)
      if (!datalist.length){
        this.onItemAddClick()
      }
      // let minCount = this.getMinCount()
      // let datalist = this.iteminfo.config.datalist
      // if (datalist && datalist.length > minCount) {      //大于最小数量的时候,删除
      // }else{
      //
      // }
    },
    getItemUrl (item) {
      let src = require('../../../assets/tempmenu/img_picture_single.png')
      if (this.iteminfo.config.displayType === 1) {
        src = require('../../../assets/tempmenu/img_picture_single.png')
      } else if (this.iteminfo.config.displayType === 2) {
        src = require('../../../assets/tempmenu/img_picture_abreast.png')
      }
      if (item.picurl) {
        src = item.picurl
      }
      return src
    },
    choicePic (item) {
      this.clickItem2ShowPicModal = item
      this.$refs.picChoiceWidget.show()
    },
    picChoiceOk (data) {
      if (data && data.length) {
        let pic = data[0]
        this.clickItem2ShowPicModal.picurl = pic.url
        //图片选择,选择图片时,需要上传这个链接;非选择图片,需要为空
        this.clickItem2ShowPicModal.contentLink = pic.linkurl
        this.clickItem2ShowPicModal.title = pic.title
        this.clickItem2ShowPicModal.width = pic.width
        this.clickItem2ShowPicModal.height = pic.height
      }
    },

    showMaterialModal (item, index) {
      this.clickItem2ShowMaterialModal = item
      this.$refs.materialChoiceWidget.show()
    },

    materialChoiceOk (data) {
      if (data && data.length > 0) {
        let item = this.clickItem2ShowMaterialModal
        item.jumpObj.linkUrl = data[0].url
        this.$nextTick(() => {
          this.checkInputOverflow()
        })
      }
    },

    /**
     * 获取最低显示数量
     */
    getMinCount () {
      return 2
    },
  }
}
</script>

<style lang="scss" scoped>
  .modal-setting ::v-deep {

    .ivu-modal-body {
      padding: 0;
      display: flex;
      justify-content: center;
      align-content: center;
    }

    //标题下横线
    .ivu-modal-header {
      border-bottom: none;
    }

    //确认取消按钮上面红线
    .ivu-modal-footer {
      border-top: none;
    }
  }

  .list-container {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-content: flex-start;
    flex-wrap: wrap;
    overflow-x: hidden;
  }

  .item {
    width: 140px;
    height: 170px;
    flex-direction: row;
    margin-bottom: 10px;
  }

  .item-selected {
    //border-color: #0EA4FB;
    //border-width: 2px;
    border: 2px solid #0EA4FB;
  }

  .item-normal {
    //border-color: #0EA4FB;
    //border-width: 2px;
    border: 2px solid white;
  }

  .item-editable {
    display: none;
  }

  .item:hover .item-editable {
    display: flex;
  }

  .lin2 {
    color: #333;
    max-width: 600px;
    font-size: 13px;
    line-height: 20px;
    //height: 40px;
    //margin-top: 6px;
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box; /** 对象作为伸缩盒子模型显示 **/
    -webkit-box-orient: vertical; /** 设置或检索伸缩盒对象的子元素的排列方式 **/
    -webkit-line-clamp: 2; /** 显示的行数 **/
    overflow: hidden; /** 隐藏超出的内容 **/
  }


  .triangle {
    width: 0;
    height: 0;
    border-color: transparent #0F8CFB;
    border-width: 0 25px 25px 0;
    border-style: solid;
  }
  .input-link ::v-deep {
    .ivu-input-group-append {
      border: none;
    }
  }
</style>
